import React from 'react'
import Typography from "@mui/material/Typography";
import LanguageLayout from '../../layout/languages';

const Language = () => {
  return (
    <div className="mainDiv">
         <Typography className="heading">Languages</Typography>
        <LanguageLayout /> 
    </div>
  )
}

export default Language

